import { Injectable } from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { TranslateService } from '@ngx-translate/core';


@Injectable()
export class CustomPaginator extends MatPaginatorIntl {

  constructor(private translateService: TranslateService ){
    super();
    
    this.itemsPerPageLabel = this.translateService.instant("customPage.customLabel");
    this.nextPageLabel = this.translateService.instant("customPage.nextPage");
    this.previousPageLabel = this.translateService.instant("customPage.previousPage");

    this.getRangeLabel = (page: number, pageSize: number, length: number): string =>{
      const amountPages = Math.ceil(length / pageSize);
        return this.translateService.instant("customPage.page", {page: page + 1, AmountPages: amountPages})
    }
  }
}